import { render, staticRenderFns } from "./OrderShippingMethod.vue?vue&type=template&id=0b8bd423"
import script from "./OrderShippingMethod.vue?vue&type=script&lang=js"
export * from "./OrderShippingMethod.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports